/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `hsa_stress_data` message.
 *
 * User's current stress data used for HSA custom data logging
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class HsaStressDataMesg : Mesg {
    public constructor() : super("HsaStressData", Profile.MesgNum.HSA_STRESS_DATA)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** processing_interval, in s. Processing interval length in seconds */
    public var processingInterval: UShort?
        get() = getFieldValue(PROCESSING_INTERVAL_FIELD_NUM) as? UShort
        set(value) = setFieldValue(PROCESSING_INTERVAL_FIELD_NUM, value)

    /** Number of values stored in stress_level. */
    public val numStressLevel: Int
        get() = getField(STRESS_LEVEL_FIELD_NUM)?.numValues ?: 0

    /** stress_level, in s. Stress Level: [0,100] Off wrist: -1 Excess motion: -2 Not enough data: -3 Recovering from exercise: -4 Unidentified: -5 Blank: -16 */
    public var stressLevel: List<Byte?>?
        get() {
            val field = getField(STRESS_LEVEL_FIELD_NUM) ?: return null
            return List(field.numValues) { getStressLevel(it) }
        }
        set(value) {
            removeField(STRESS_LEVEL_FIELD_NUM)
            value?.forEachIndexed { index, element -> setStressLevel(index, element) }
        }

    public fun getStressLevel(index: Int): Byte? =
        getFieldValue(STRESS_LEVEL_FIELD_NUM, index) as? Byte

    public fun setStressLevel(index: Int, value: Byte?) {
        setFieldValue(STRESS_LEVEL_FIELD_NUM, value, index)
    }

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val PROCESSING_INTERVAL_FIELD_NUM: UByte = 0u
        public const val STRESS_LEVEL_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[0] = Field("ProcessingInterval", 0u, BaseType.UINT16, 1.0, 0.0, "s", false)
            fields[1] = Field("StressLevel", 1u, BaseType.SINT8, 1.0, 0.0, "s", false)
            return fields
        }
    }
}
